import { createRoute } from '@tanstack/react-router';
import { adminParentRoute } from 'pages/admin/adminParentRoute';
import { zodPathParamId } from 'routes/routeUtils';
import { z } from 'zod';

export const adminPharmacyRoute = createRoute({
  getParentRoute: () => adminParentRoute,
  path: '/pharmacies/$id',
  params: z.object({ id: zodPathParamId }),
  validateSearch: z.object({
    tab: z.enum(['general', 'team', 'credentials', 'emails']).default('general'),
  }),
}).lazy(() =>
  import('pages/admin/Pharmacies/AdminPharmacyPage/AdminPharmacyPage').then((d) => d.Route)
);
